var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ adv: _vm.type == 'adv', pro: _vm.type == 'pro', bns: _vm.type == 'bns' },style:({
    width: _vm.size === 'big' ? '47px' : '34px',
    height: _vm.size === 'big' ? '21px' : '14.6px',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }